import React from 'react';
import FieldGenerico from '../componentes_generales/componentes_formulario/fields/fieldgenerico';
import FieldSelect from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselect';
import FieldSelectAsync from '../componentes_generales/componentes_formulario/fields/fieldselect/fieldselectasync';
import FieldBusqEspecifica from '../componentes_generales/componentes_formulario/fields/busqueda_especifica/fieldselectasync-busq-especif';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerEdit} from '../componentes_generales/componentes_formulario/contenedores/';
import { Field, reduxForm , formValueSelector  } from 'redux-form';
import { Label, LabelRadio } from '../componentes_generales/componentes_formulario/labels/';
 import { cargarCatalogos_Otros, cargarCatalogos, cargarCatalogosGenerico, cargarCatalogosAsync, cargarCatalogosGenericoAsync, cargarCatalogosAsyncDependiente, cargarCatalogosAsyncDobleDependiente } from '../../funciones_globales/catalogos';
import { cargar_Cliente, cargar_ValoresIniciales } from '../../actions/clientes/act_cli01';
import { connect } from 'react-redux';
import global_axios from '../../funciones_globales/interaccionapi';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import styled from 'styled-components';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
//import { get_FechaSistema_FormatoString } from '../../funciones_globales/utils';
import { getItemDatosSesion } from '../../funciones_globales/manejosesion';
import { formatearLabel } from '../../funciones_globales/format';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { validarPermisoAcceso } from '../../funciones_globales/utils';


const tipo_cliente = [{value: 'P', label: 'PEQUEÑO (P)'},{value: 'M', label: 'MEDIANO (M)'},{value: 'G', label: 'GRANDE (G)'}]

const maxLength = max => value =>
    value && value.length > max ? `Hasta ${max} caracteres` : undefined;

const required = value => value ? undefined : 'Campo requerido';
const maxLength20 = maxLength(20);
const maxLength10 = maxLength(10);
const maxLength50 = maxLength(50);
const maxLength100 = maxLength(100);
const maxLength700 = maxLength(700);
const maxLength140 = maxLength(140);

const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ?
'Email inválido' : undefined;

const number = value => value && isNaN(Number(value)) ? 'Solo números' : undefined

const ContenedorBotonAdd = styled.div`
    padding-top: 20px;
    @media (max-width: 991px){
    padding: 0px;
    }
`;

class FormCli01 extends React.Component{
    constructor(props){
        super(props);
            this.state = {
                estado_civil: [],
                oficial_credito: [],
                origen_ingresos: [],
                pais: [],
                forma_pago: [],
                tipo_credito: [],
                status_cli: [],
                recaudador: [],
                vendedores: [],
                
                editando: 'N',
                copiaCedula:'',
                permiso: null,
                

                opt_tipo: [],
                opt_clase: [],
                opt_tipo_identificacion: [],
                status_tipocli: [],
                grid_direcciones: [],
                columnDefs_dir:        [{   header: "N°",
                                            field: "secuencia",
                                            width: 30,
                                            type: "num_entero"                                                 
                                        },
                                        {   header: "Dirección",
                                            field: "direccion",
                                            width: 650,
                                            type: "string"                                                 
                                        },
                                        {   header: "Ciudad",
                                            field: "ciudad",
                                            width: 125,
                                            type: "string"                                                 
                                        },
                                        {   header: "",
                                            field: "eliminar",
                                            width: 60,
                                            type: "link_elim"                                                
                                        }
                                    ],
            };
            
        this.gridOptions = {
            context: {
                componentParent: this
            },
            enableColResize: true,
            enableCellChangeFlash: true,
            onCellValueChanged: (event)=>{
            }
               
        };
            this.editar = this.editar.bind(this);
            this.addDirreccion = this.addDirreccion.bind(this);
            this.guardarCliente = this.guardarCliente.bind(this);
    }


    methodFromParent(id, datos_fila) {
        var mensaje;
       
        mensaje = window.confirm("¿Desea eliminar la dirección seleccionada?"); 
        
        if (mensaje){
            this.eliminarDireccion(datos_fila ,id ) 
        }
        
    }

    eliminarDireccion(datos_fila ,id){
        
        this.setState(
            {grid_direcciones: this.immutableDelete(this.state.grid_direcciones, id)}
        )
    }

    immutableDelete (arr, index) {
        var i = parseInt(index, 10);
        return arr.slice(0,i).concat(arr.slice(i+1));
    }

    addDirreccion(){

        if(this.props.ciudadAdd && this.props.dir_add){
            var item = {};
            let indexfinal = this.state.grid_direcciones.length - 1;

            if(indexfinal === -1){
                item.secuencia = 1;
            }else{
                item.secuencia = parseInt(this.state.grid_direcciones[indexfinal].secuencia, 10)+ 1;
            }
            
            item.direccion = this.props.dir_add.toString().toUpperCase();
            item.ciudad = formatearLabel(this.props.ciudadAdd.label)
            item.ciudadCode = this.props.ciudadAdd.value

            this.setState({ grid_direcciones: this.immutablePush(this.state.grid_direcciones, item) },()=>{
                this.props.change('dir_add', '')
                this.props.change('ciudadAdd', '');
            })
        }else{
            alert("Ingrese direccion y una ciudad asociada")
        }
    }

    immutablePush(array, newItem){
        return [ ...array, newItem ];  
    }

    guardarCliente(e){
        let errors = '';
        let continuar = true

        let fechaProceso = getFechaProcesoPorModulo('01');

        e.NombreCliente = e.NombreCliente?e.NombreCliente.toUpperCase().trim():null;
        e.apellido = e.apellido?e.apellido.toUpperCase().trim():null;
        
        e.localidad = '01';
        e.direcciones = this.state.grid_direcciones;

        let config_request;
        
        let operacionLocal = null;
      
        if(this.state.editando.toString()==='N'){
            config_request = {
                method: 'POST',
                url: '/clientes',
                data: e
            }
            operacionLocal = 'G';
        }else if(this.state.editando.toString()==='S'){

            e.Usuario= getItemDatosSesion('usuario')
            e.IdRegAudit = this.props.IdRegAudit
            e.FechaSistema = fechaProceso;

            config_request = {
                method: 'PUT',
                url: '/clientes/'+this.props.codigo.toString(),
                data: e
            }
            operacionLocal = 'M';
        }
        
        if(this.props.tipo_persona==='J'){
            /* Validacion por persona juridica */

            if(!this.props.tamano_empresa){
                errors += ' - Ingrese un tamaño para la empresa\n'
                continuar = false;
            }
        }else if(this.props.tipo_persona==='N'){
            if(!this.props.estado_civil){
                errors += ' - Seleccione un estado civil\n'
                continuar = false; 
            }

            if(!this.props.origen_ingresos){
                errors += ' - Seleccione un origen de ingreso\n'
                continuar = false;
            }

            if(!this.props.sexo){
                errors += ' - Seleccione un sexo\n'
                continuar = false;
            }
        }else{
            errors += ' - Seleccione tipo persona\n'
            continuar = false;
        }

        if(this.props.dir_add || this.props.ciudadAdd){
            let msg = window.confirm(' - Existen items sin añadir en opcion: "Dirección adicional", ¿continuar y descartar cambios no ingresados?');
            if(msg === false){
                continuar = false;
                errors += '- Operación detenida por el usuario\n';
            }
        }
        
        let operacion = validarPermisoAcceso(operacionLocal, this.props.permiso)
        if(operacion.esValido===false){
            continuar = false;
            errors += operacion.msg
        }

        console.log('DATA ENVIADA: ', e)
        if(continuar===true){
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg);            
                this.props.reset();
                this.props.cargar_ValoresIniciales();
                this.setState({grid_direcciones: []});
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert(errors)
        }
    }

    submit(e){
        
        let proceder = false;
        let tipo = "";

        let cedulaRuc = this.props.cedula_ruc;
        if(this.props.tipo_persona==='N'){
            tipo='CEDULA'; //VERIFICA CON OPCION CEDULA
        }else if(this.props.tipo_persona==='J'){
            tipo='RUC'; //VERIFICA CON OPCION RUC
        }else if(this.props.tipo_persona!=='J' && this.props.tipo_persona!=='N'){
            alert("El número de "+tipo+" es inválido")
        }
        //validación de cedula o ruc para que no se repita

        let config_request_validacion={
            method: 'POST',
            url: 'clientes/validacion-cedula-repetida',
            data: {cedula: cedulaRuc}
        };
        if(this.state.copiaCedula!==cedulaRuc){
            global_axios(config_request_validacion)
            .then((response)=> {
                let validacionCedula=response.data.validacion;
                if(validacionCedula){
                    alert(`El número de ${this.props.TipoIdentificacion==='C'?'cédula':'ruc'} ya se encuentra registrado en el sistema `)
                }else{
                     //console.log('TIPO ID: ', cedulaRuc.length)
                    if(this.props.TipoIdentificacion === 'IX' || this.props.TipoIdentificacion === 'P'){
                        tipo = '';
                        this.guardarCliente(e);
                    }
                    
                    if(this.props.TipoIdentificacion === 'C' && cedulaRuc.length !== 10){
                        tipo = '';
                        alert('La cédula solo puede ser de 10 dígitos');
                    }
                    
                    if(this.props.TipoIdentificacion === 'R' && cedulaRuc.length !== 13){
                        tipo = '';
                        alert('El RUC solo puede ser de 13 dígitos');
                    }

                    if(tipo!==''){
                        let config_request = {
                            method: 'GET',
                            url: '/verificador?tipo='+tipo+'&value='+this.props.cedula_ruc
                        };
                        global_axios(config_request)
                        .then((response)=> {
                            console.log('respuesta validacion: ', response)
                            if(response.data.resultado===0){
                                proceder = true;
                            }else{
                                proceder = false;
                                //alert("El número de "+tipo+" es inválido")
                                alert(`El número de ${this.props.TipoIdentificacion==='C'?'cédula':'ruc'} para el tipo de persona ${this.props.tipo_persona==='N'?'natural':'jurídica'} es inválido`)
                            }
                            if(proceder===true){
                                this.guardarCliente(e) 
                            }                
                        })
                        .catch((error)=>{
                            alert(error.response?error.response.data.msg:error.message);       
                        })
                    }
                }
            })
            .catch((error)=>{
                alert(error.response?error.response.data.msg:error.message);       
            })
        }else{
            if(this.props.TipoIdentificacion === 'IX' || this.props.TipoIdentificacion === 'P'){
                tipo = '';
                this.guardarCliente(e);
            }
            
            if(this.props.TipoIdentificacion === 'C' && cedulaRuc.length !== 10){
                tipo = '';
                alert('La cédula solo puede ser de 10 dígitos');
            }
            
            if(this.props.TipoIdentificacion === 'R' && cedulaRuc.length !== 13){
                tipo = '';
                alert('El RUC solo puede ser de 13 dígitos');
            }

            if(tipo!==''){
                let config_request = {
                    method: 'GET',
                    url: '/verificador?tipo='+tipo+'&value='+this.props.cedula_ruc
                };
                global_axios(config_request)
                .then((response)=> {
                    console.log('respuesta validacion: ', response)
                    if(response.data.resultado===0){
                        proceder = true;
                    }else{
                        proceder = false;
                        //alert("El número de "+tipo+" es inválido")
                        alert(`El número de ${this.props.TipoIdentificacion==='C'?'cédula':'ruc'} para el tipo de persona ${this.props.tipo_persona==='N'?'natural':'jurídica'} es inválido`)
                    }
                    if(proceder===true){
                        this.guardarCliente(e) 
                    }                
                })
                .catch((error)=>{
                    alert(error.response?error.response.data.msg:error.message);       
                })
            }
        }
        

    }

    editar(e){
        this.props.reset();        
        const {consulta_cliente} = this.props;
        this.setState({editando: 'S'})
       
        if(consulta_cliente){           
            this.setState({grid_direcciones: [], codigo: consulta_cliente.value});

            this.props.cargar_Cliente_a_Editar(consulta_cliente.value).then(()=>{
                this.setState({copiaCedula: this.props.cedula_ruc})
                this.setState({grid_direcciones: this.props.detalle_direcciones })
            })

        }else{
            alert('Ud. no ha seleccionado un cliente.');                
        }
    }

    clear(){
        this.setState({grid_direcciones: [], editando:'N'});
        this.props.reset();
        this.props.cargar_ValoresIniciales();
    }
    validarCedulaRucExistente(){
        
        //validación de cedula o ruc para que no se repita
        let cedulaRuc=this.props.cedula_ruc;
        let config_request_validacion={
            method: 'POST',
            url: 'clientes/validacion-cedula-repetida',
            data: {cedula: cedulaRuc}
        };
        if(this.state.editando.toString()==='N' && this.props.TipoIdentificacion!=='IX'){
            if(cedulaRuc!=="" && cedulaRuc!==null && cedulaRuc!==undefined){
                global_axios(config_request_validacion)
                .then((response)=> {
                    let validacionCedula=response.data.validacion;
                    if(validacionCedula){
                        alert(`El número de ${this.props.TipoIdentificacion==='C'?'cédula':'ruc'} ya se encuentra registrado en el sistema `)
                    }
    
                })
                .catch((error)=>{
                    alert(error.response?error.response.data.msg:error.message);       
                })
            }
        }
 
    }
    componentDidMount(){
        
        Promise.all([  
            cargarCatalogos_Otros('GEN-VENDEDORES'), cargarCatalogos('TIPODOCUMENTO'),          
            cargarCatalogos('CLIENTECLASE'),cargarCatalogos('TIPOCLIEN'), cargarCatalogos('CIVIL'), cargarCatalogos('OING'), cargarCatalogos('FORMAPAGO'), cargarCatalogos('TIPOCREDI'),
            cargarCatalogos('STATUSCLI'), cargarCatalogos_Otros('CLI-OFICIALES'), cargarCatalogosGenerico('/recaudadores'), this.props.generar_LogAuditoriaIngresoForm('0101') , cargarCatalogos('TIPOCLI')           
        ])
        .then(([vendedores_cat, result_tipoIdentificacion, result_clase, result_tipo ,result_civil, result_ingresos, result_formaPago, result_tipoCredit, result_statusClient, result_oficiales, result_recaudadores, result_codigo_next, result_tipocli]) => {            
            this.setState({
                vendedores: vendedores_cat, opt_tipo_identificacion: result_tipoIdentificacion, 
                opt_clase: result_clase, opt_tipo: result_tipo, estado_civil: result_civil, origen_ingresos: result_ingresos, forma_pago: result_formaPago, tipo_credito: result_tipoCredit, 
                status_cli: result_statusClient, oficial_credito: result_oficiales, recaudador: result_recaudadores, codigo: result_codigo_next, permiso: this.props.permiso, status_tipocli: result_tipocli
            })            
        })
        .catch(err => {
            console.log(err);
        });        
        
        this.props.cargar_ValoresIniciales();                
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0101');
    }

    getOptions_Pais(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('PAIS', input, callback)
        }
    }
    
    getOptions_Zona(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('ZONACLIEN', input, callback)
        }
    }

    // getOptions_Vendedores(input, callback){
    //     if (input.toString().length >= 2 ){
    //         let cadena_busq = '?cadena_busq=' + input;
    //         cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
    //     }
    // }

    getOptions_Ciudad(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('CIUDAD', input, callback)
        }
    }

    getOptions_Provincia(input, callback){
        if (input.toString().length >= 2 ){
            cargarCatalogosAsync('PROVINCIA', input, callback);
        }
        
    }

    getOptions_Canton(input, callback){
        const { provincia_value } = this.props
        if (input.toString().length >= 2 ){
            cargarCatalogosAsyncDependiente('CANTON', provincia_value.value, input, callback);
        }
        
    }
    
    getOptions_Parroquia(input, callback){
        const { provincia_value, canton_value } = this.props;

        var canton = '';
        canton = (canton_value!==undefined?(canton_value!==null?canton_value.value:null):null)
        if (input.toString().length >= 2 ){
            cargarCatalogosAsyncDobleDependiente('PARROQUIA', provincia_value.value, canton, input, callback);
        }
    }
    
    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    //Valida si deben estar activas los select de canton y parroquia
    validacionSitios(op){
        var result = true //DISABLED X DEFECTO
        const { provincia_value, canton_value } = this.props;

        if(provincia_value){
            switch (op) {
                case 'CA':
                    if(provincia_value.value!==undefined && provincia_value.value!=='' && provincia_value.value!==null){
                        result = false;
                    }
                    break;
                case 'PQ':
                    if( (provincia_value.value!==undefined && provincia_value.value!=='' && provincia_value.value!==null) && (canton_value!==undefined && canton_value!=='' && canton_value!==null) ){
                        result = false;
                    }
                    break;
            
                default:
                    break;
            }
        }

        return result;
    }

    //RESETEA CANTON Y PARROQUIA A NULL CUANDO SE DESELECCIONA LA PROVINCIA
    resetCantonPQ(){
       
        if(this.props.provincia_value===null){
            this.props.change('canton', null)
            this.props.change('parroquia', null)
        }
    }

    //ACTUALIZACION DE DEUDAS CLIENTE
    actualizarDeudasCliente(){
        if(this.props.codigo){
            let config_request = {
                method: 'POST',
                url: '/clientes/'+this.props.codigo.toString()+'/sincronizaciondeudas'
            }
    
            this.props.cambiar_VisualizacionLoading(true);
            global_axios(config_request)
            .then((response)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(response.data.msg);            
            })
            .catch((error)=>{
                this.props.cambiar_VisualizacionLoading(false);
                alert(error.response?error.response.data.msg:error.message);
            })
        }else{
            alert('Cargar un cliente antes de actualizar')
        }
    }
    
    render(){        
        const { handleSubmit, submitting } = this.props
        
        return(
            <ContenedorForm porc_ancho={93}>
                <HeaderForm>
                    <TituloForm>Mantenimiento de Cliente</TituloForm>
                </HeaderForm>
                <CuerpoForm>                   
                    <ContainerEdit>
                    <Row>                  
                        <div className='col-md-5'>
                            <Field
                            label="Cód. Cliente:"
                            name="consulta_cliente"
                            component={ FieldBusqEspecifica }                                   
                            loadOptions={this.getOptions_Clientes.bind(this)}
                            getItemEspecifico={this.editar.bind(this)}
                            func_OnFocus={this.clear.bind(this)}
                            textoBoton="Sel."
                            icono="fa fa-check-circle-o"/>
                        </div>
                        <div className='col-md-1'>
                            <Field
                                name="codigo"
                                type='text'
                                component={ FieldGenerico }
                                readonly={true}
                                label="Código:"/>
                        </div>
                        <div className='col-md-4'>
                            <Field
                                name="nombre"
                                type='text'
                                component={ FieldGenerico }
                                readonly={true}
                                label="Nombre Completo:"/>
                        </div>
                        <div className='col-md-2'>
                            <Field
                                name="fecha_nacimiento"
                                component={ FieldGenerico }
                                readonly={true}
                                label="Fecha de creación:"
                                validate={required}/> 
                        </div>
                    </Row>             
                    </ContainerEdit>   
                    <form onSubmit={handleSubmit(this.submit.bind(this))}>                                   
                        <Row>                            
                            <div className='col-md-2'>
                                <Field
                                    name="TipoIdentificacion"
                                    component={ FieldSelect }
                                    label="Tipo Identificación:"                                    
                                    options={this.state.opt_tipo_identificacion}
                                    validate={required}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    func_OnBlur={this.validarCedulaRucExistente.bind(this)}
                                    name="cedula_ruc"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Cédula/Ruc:"
                                    validate={[maxLength20, required]}
                                   />
                            </div>
                            <div className='col-md-2'>
                                <Label>Tipo persona</Label>
                                <LabelRadio>
                                    <Field
                                        name='tipo_persona'
                                        component='input'
                                        type="radio"
                                        value="N"
                                    />{' '}Natural
                                </LabelRadio >
                                <LabelRadio>
                                    <Field
                                        name='tipo_persona'
                                        component='input'
                                        type="radio"
                                        value="J"
                                    />{' '}Jurídica
                                </LabelRadio>
                                 
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="NombreCliente"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Nombre/Razon Social:"
                                    mayusculas={true}
                                    validate={[maxLength140, required]}/>
                            </div>
                            <div className='col-md-2'>
                                <Field 
                                    name="apellido" 
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Apellido:"
                                    mayusculas={true}
                                    disabled={this.props.tipo_persona==='J'?true:false}
                                    validate={[maxLength50]}/>
                            </div>                            
                            <div className='col-md-2'>
                                <Field 
                                    name="NombreComercial" 
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Nombre Negocio:"
                                    mayusculas={true}                                    
                                    validate={[maxLength50]}
                                    />
                            </div>                            
                        </Row>
                        <Row>  
                            <div className='col-md-2'>
                                <Field 
                                    name="CedulaRepresentante" 
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Ced. Representante:"
                                    mayusculas={true}
                                    validate={[maxLength10]}
                                />
                            </div>  
                            <div className='col-md-2'>
                                <Field
                                    name="representante_cia"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Representante CIA.:"
                                    validate={maxLength50} //required
                                    mayusculas={true}
                                /> 
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="celular_representante"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Celular:"
                                    validate={number} //required
                                /> 
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="email_representante"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Email (Facturación):"
                                    validate={[email, required]} //
                                /> 
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="tipo"
                                    component={ FieldSelect }
                                    label="Tipo:"
                                    options={this.state.opt_tipo}
                                />
                            </div>                       
                            <div className='col-md-2'>
                                <Field
                                    name="Calificacion"
                                    component={ FieldSelect }
                                    label="Calificación:"
                                    options={this.state.opt_clase}
                                />
                            </div>                                                                              
                        </Row>
                        <Row> 
                            <div className='col-md-2'>
                                <Field
                                    name="cupo"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Cupo:"
                                    validate={[number,required]}/>
                            </div> 
                            <div className='col-md-2'>
                                <Field
                                    name="tipo_credito"
                                    component={ FieldSelect }
                                    label="Tipo de credito:"                                    
                                    options={this.state.tipo_credito}
                                    validate={required}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="forma_pago"
                                    component={ FieldSelect }
                                    label="Forma pago:"                                    
                                    options={this.state.forma_pago}
                                    validate={required}/>
                            </div>                              
                            <div className='col-md-2'>
                                <Field
                                    name="status_cli"
                                    component={ FieldSelect }
                                    label="Estatus:"                                    
                                    options={this.state.status_cli}
                                    validate={required}/>
                            </div>                           
                            <div className='col-md-2'>
                                <Field
                                    name="tamano_empresa"
                                    component={ FieldSelect }
                                    label="Tamaño empresa:"
                                    options={tipo_cliente}
                                    disabled={this.props.tipo_persona==='N'?true:false}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="origen_ingresos"
                                    component={ FieldSelect }
                                    label="Origen ingresos:"
                                    options={this.state.origen_ingresos}
                                    //validate={required}
                                    disabled={this.props.tipo_persona==='J'?true:false}/>
                            </div> 
                                                                                                              
                        </Row>
                        <Row>                             
                            <div className='col-md-2'>                                
                                <Label>Sexo</Label>                               
                                <LabelRadio>
                                    <Field
                                        name='sexo'
                                        component='input'
                                        type="radio"
                                        value="M"
                                        disabled={this.props.tipo_persona==='J'?true:false}
                                    />{' '}Masculino
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='sexo'
                                        component='input'
                                        type="radio"
                                        value="F"
                                        disabled={this.props.tipo_persona==='J'?true:false}
                                    />{' '}Femenino
                                </LabelRadio>   
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="estado_civil"
                                    component={ FieldSelect }
                                    label="Estado civil:"
                                    options={this.state.estado_civil}
                                    disabled={this.props.tipo_persona==='J'?true:false}
                                    />
                            </div>
                            <div className='col-md-2'>                                
                                <Field
                                    name="cedula_conyuge"
                                    component={ FieldGenerico }
                                    label="Cédula cónyuge:"
                                    disabled={this.props.tipo_persona==='J'?true:false}
                                    validate={[number,maxLength10]}/>
                            </div>
                            <div className='col-md-2'>                                
                                <Field
                                    name="nombre_conyuge"
                                    component={ FieldGenerico }
                                    label="Nombre cónyuge:"
                                    mayusculas={true}
                                    disabled={this.props.tipo_persona==='J'?true:false}
                                    validate={maxLength50}/>
                            </div>  
                            <div className='col-md-2'>                                
                                <Field
                                    name="apellido_conyuge"
                                    component={ FieldGenerico }
                                    label="Apellido cónyuge:"
                                    mayusculas={true}
                                    disabled={this.props.tipo_persona==='J'?true:false}
                                    validate={maxLength50}/>
                            </div> 
                            <div className='col-md-2'>
                                <Field
                                    name="telefono_convencional"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Convencional:"
                                    validate={[number,maxLength10]}//required
                                    />
                            </div>                                                                              
                        </Row>
                        <Row>                            
                            <div className='col-md-12'>
                                <Field
                                    name="direccion_principal"
                                    component={ FieldGenerico }
                                    label="Dirección principal:"
                                    validate={[maxLength100, required]}/>
                            </div>
                        </Row>                        
                        <Row>
                            <div className='col-md-2'>
                                <Field
                                    name="pais"
                                    component={ FieldSelectAsync }
                                    label="País:"                                    
                                    loadOptions={this.getOptions_Pais.bind(this)}
                                    validate={required}/> 
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="provincia"
                                    component={ FieldSelectAsync }
                                    label="Provincia:"
                                    loadOptions={this.getOptions_Provincia.bind(this)}
                                    validate={required}
                                    onBlur={this.resetCantonPQ.bind(this)}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="canton"
                                    component={ FieldSelectAsync }
                                    label="Cantón:"
                                    loadOptions={this.getOptions_Canton.bind(this)}
                                    validate={required}
                                    disabled={this.validacionSitios('CA')}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="parroquia"
                                    component={ FieldSelectAsync }
                                    label="Parroquia:"
                                    loadOptions={this.getOptions_Parroquia.bind(this)}
                                    validate={required}
                                    disabled={this.validacionSitios('PQ')}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="zona"
                                    component={ FieldSelectAsync }
                                    label="Zona:"
                                    loadOptions={this.getOptions_Zona.bind(this)}
                                    validate={required}/>
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="ciudad"
                                    component={ FieldSelectAsync }
                                    label="Subzona(Ciudad):"
                                    loadOptions={this.getOptions_Ciudad.bind(this)}
                                    validate={required}/>
                            </div>
                        </Row>
                        <Row>
                            <div className='col-md-2'>
                                <Field
                                    name="contacto_cia"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Contacto en la empresa:"
                                    mayusculas={true}
                                    //validate={required}
                                    />
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="celular_contacto_cia"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Celular:"
                                    validate={[number,maxLength10]}//required
                                    />
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name='email_contacto_cia'
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Email:"
                                    validate={email} //required
                                /> 
                            </div> 
                            <div className='col-md-2'>
                                <Field
                                    name="oficial_credito"
                                    component={ FieldSelect }
                                    label="Oficial de credito:"
                                    options={this.state.oficial_credito}
                                    validate={required}/>
                            </div>
                            <div className='col-md-2'>
                                <Field 
                                    name="vendedorCod"
                                    component={ FieldSelect }
                                    label="Vendedor:"
                                    //loadOptions={this.getOptions_Vendedores.bind(this)}
                                    options={this.state.vendedores}
                                    validate={required}/>                                    
                            </div>
                            <div className='col-md-2'>
                                <Field
                                    name="recaudador"
                                    component={ FieldSelect }
                                    label="Recaudador:"
                                    options={this.state.recaudador}
                                    // validate={required}
                                />
                            </div>                                                                          
                        </Row>                        
                        <Row>                                                                                       
                            {/* <div className='col-md-4'>
                                <Field
                                    name="cel_recaudador"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Celular del recaudador:"/>
                            </div> */}
                        </Row>
                        <Row>
                            <div className='col-md-12'>
                                <Field
                                    name="oberservaciones"
                                    type='text'
                                    component={ FieldGenerico }
                                    label="Observaciones:"
                                    mayusculas={true}                                    
                                    validate={[maxLength700]}/>
                            </div>
                        </Row>
                        <Row>
                            <div className='col-md-2'>
                                <Label>Parte relacionada:</Label>                                
                                <LabelRadio>
                                    <Field
                                        name='parte_relacionada'
                                        component='input'
                                        type="radio"
                                        value="SI"
                                        />{' '}Si
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='parte_relacionada'
                                        component='input'
                                        type="radio"
                                        value="NO"
                                    />{' '}No
                                </LabelRadio>  
                            </div>
                            <div className='col-md-2'>
                            <Field
                                name="status_tipocli"
                                component={ FieldSelect }
                                label="Instancia Juridica:"                                    
                                options={this.state.status_tipocli}
                                />
                            </div>
                            <div className='col-md-2'>
                                <Label>Contribuyente Especial: </Label>
                                <LabelRadio>
                                    <Field
                                        name='ContbEspecial'
                                        component='input'
                                        type="radio"
                                        value="S"
                                    />{' '}Si
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='ContbEspecial'
                                        component='input'
                                        type="radio"
                                        value="N"
                                    />{' '}No
                                </LabelRadio>  
                            </div>
                            <div className='col-md-2'>
                                <Label>Cobro flete:</Label>                                
                                <LabelRadio>
                                    <Field
                                        name='flete'
                                        component='input'
                                        type="radio"
                                        value="S"
                                        />{' '}Si
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='flete'
                                        component='input'
                                        type="radio"
                                        value="N"
                                    />{' '}No
                                </LabelRadio>
                            </div>
                            <div className='col-md-1'>
                                <Label>Prospecto:</Label>                                
                                <LabelRadio>
                                    <Field
                                        name='Cprospecto'
                                        component='input'
                                        type="radio"
                                        value="S"
                                        />{' '}Si
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='Cprospecto'
                                        component='input'
                                        type="radio"
                                        value="N"
                                    />{' '}No
                                </LabelRadio>
                            </div>
                            <div className='col-md-3'>
                                <Label>Naturaleza Seguro:</Label>                                
                                <LabelRadio>
                                    <Field
                                        name='NaturalezaSeguro'
                                        component='input'
                                        type="radio"
                                        value="N"
                                        />{' '}Nominado
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='NaturalezaSeguro'
                                        component='input'
                                        type="radio"
                                        value="I"
                                    />{' '}Inominado
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='NaturalezaSeguro'
                                        component='input'
                                        type="radio"
                                        value="A"
                                    />{' '}No Aplica
                                </LabelRadio>
                            </div>
                        </Row>
                        <Row>
                            <div className='col-md-2'>
                                <Label>Agente de Retencion:</Label>                                
                                <LabelRadio>
                                    <Field
                                        name='Retiene'
                                        component='input'
                                        type="radio"
                                        value="S"
                                        />{' '}Si
                                </LabelRadio>
                                <LabelRadio>
                                    <Field
                                        name='Retiene'
                                        component='input'
                                        type="radio"
                                        value="N"
                                    />{' '}No
                                </LabelRadio>
                            </div>

                        </Row>
                        <Row>
                            <div className='col-md-6'>
                                <Field
                                    name="dir_add"
                                    component={ FieldGenerico }
                                    label="Dirección adicional:"
                                    mayusculas={true}/>
                            </div>
                            <div className='col-md-3'>
                                <Field
                                    name="ciudadAdd"
                                    component={ FieldSelectAsync }
                                    label="Subzona(Ciudad):"
                                    loadOptions={this.getOptions_Ciudad.bind(this)}/>
                            </div>
                            <div className='col-md-1'>
                                <ContenedorBotonAdd>
                                    <button type="button" className='btn btn-success btn-sm' onClick={this.addDirreccion}><i className="fa fa-plus" ></i></button>
                                </ContenedorBotonAdd>
                            </div>
                        </Row>
                        <Row>
                            <div className = 'col-md-9'>
                                <AgGridRender altura='100px' data={this.state.grid_direcciones} columnas={this.state.columnDefs_dir} 
                                gridOptions={this.gridOptions} onGridReady={this.onGridReady}/>
                            </div>
                        </Row>
                        <Row>
                            <div className='col-md-12'>
                                <div className="btn-group pull-right">
                                    <button type="submit" className='btn btn-success btn-sm' disabled={submitting}>
                                        <i className="fa fa-floppy-o fa-lg"></i> Guardar
                                    </button>                                
                                    <button type="button" className='btn btn-sm' onClick={this.clear.bind(this)}>
                                        <i className="fa fa-trash-o fa-lg"></i> Limpiar
                                    </button>
                                    <button type="button" className='btn btn-info btn-sm' onClick={this.actualizarDeudasCliente.bind(this)}>
                                        <i className="fa fa-refresh fa-lg"></i> Act. Customer
                                    </button>
                                </div>
                            </div> 
                        </Row>                        
                    </form>
                </CuerpoForm>
          </ContenedorForm>
        )
    }
}

FormCli01 = reduxForm({
    form: 'form_cli01', enableReinitialize: true,
})(FormCli01)

const selector = formValueSelector('form_cli01') 
FormCli01 = connect(  
    state => ({
        initialValues: state.inicializacion_form.data,

        consulta_cliente: selector(state, 'consulta_cliente'),
        codigo: selector(state, 'codigo'),
        detalle_direcciones: selector(state, 'detalle_direcciones'),
        nombre: selector(state, 'nombre'),
        apellido: selector(state, 'apellido'),
        cedula_ruc: selector (state, 'cedula_ruc'),
        estado_civil: selector(state, 'estado_civil'),
        sexo: selector(state, 'sexo'),
        tipo_persona: selector(state, 'tipo_persona'),
        tipo_cliente: selector(state, 'tipo_cliente'),
        cupo: selector(state, 'cupo'),
        oficial_credito: selector(state, 'oficial_credito'),
        origen_ingresos: selector(state, 'origen_ingresos'),
        pais: selector(state, 'pais'),
        direccion_principal: selector(state, 'direccion_principal'),
        zona: selector(state, 'zona'),
        provincia_value: selector(state, 'provincia'),
        canton_value: selector(state, 'canton'),
        parroquia: selector(state, 'parroquia'),
        cedula_conyuge: selector(state, 'cedula_conyuge'),
        nombre_conyuge: selector(state, 'nombre_conyuge'),
        apellido_conyuge: selector(state, 'apellido_conyuge'),
        ciudad: selector(state, 'ciudad'),
        empresa: selector(state, 'empresa'),
        representante_cia: selector(state, 'representante_cia'),
        celular_representante: selector(state, 'celular_representante'),
        email_representante: selector(state, 'email_representante'),
        forma_pago: selector(state, 'forma_pago'),
        tipo_credito: selector(state, 'tipo_credito'),
        status_cli: selector(state, 'status_cli'),
        fecha_nacimiento: selector (state, 'fecha_nacimiento'),
        contacto_cia: selector(state, 'contacto_cia'),
        celular_contacto_cia: selector(state, 'celular_contacto_cia'),
        email_contacto_cia: selector(state, 'email_contacto_cia'),
        vendedor: selector(state, 'vendedorCod'),
        recaudador: selector(state, 'recaudador'),
        cel_recaudador: selector(state, 'cel_recaudador'),
        oberservaciones: selector( state, 'oberservaciones'),
        parte_relacionada: selector(state, 'parte_relacionada'),
        Retiene: selector(state, 'Retiene'),
        cprospecto: selector(state, 'cprospecto'),
        NaturalezaSeguro: selector(state, 'NaturalezaSeguro'),

        dir_add: selector(state, 'dir_add'),
        ciudadAdd: selector(state, 'ciudadAdd'),

        legal:  selector(state, 'status_tipocli') , //selector( state, 'legal'),
        tamano_empresa: selector( state, 'tamano_empresa'),
        TipoIdentificacion: selector(state, 'TipoIdentificacion'),

        IdRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
        fechaProceso: state.sesion.valoresSesionForm.FechaProceso,
        permiso: state.sesion.valoresSesionForm.Permiso,
    }),
    {  cargar_Cliente_a_Editar: cargar_Cliente, cambiar_VisualizacionLoading,
       cargar_ValoresIniciales, generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm }
)(FormCli01)

export default FormCli01;